/**
 * Checks if the target time is outside the availability window range.
 * @param targetTime - The target time to check.
 * @param availabilityStartTime - The availability start time.
 * @param computedAvailabilityEndTime - The computed availability end time.
 * @returns true if the target time is outside the availability window range, false otherwise.
 */

export const isOutsideAvailabilityWindowRange = (
  targetTime: number,
  availabilityStartTime: number | null,
  computedAvailabilityEndTime: number | null
) => {
  return (
    targetTime < (availabilityStartTime || 0) ||
    targetTime > (computedAvailabilityEndTime || 0)
  );
};
